module.exports = __webpack_public_path__ + "static/media/a1.7be1167.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangping/a1.mp3
// module id = Rs31
// module chunks = 0